export const enum WasteChecksheetTab {
    ACTIVE = 1,
    ARCHIVED = 2
  }